/** 
 * Copyright (c) INOVUA SOFTWARE TECHNOLOGIES.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function debounce(func, wait) {
  var _this = this;

  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var timeout;
  var args;
  var context;
  var timestamp;
  var result;

  var later = function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;

      if (!immediate) {
        result = func.apply(context, args);

        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function () {
    var callNow = immediate && !timeout;
    context = _this;

    for (var _len = arguments.length, internalArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      internalArgs[_key] = arguments[_key];
    }

    args = internalArgs;
    timestamp = Date.now();

    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

var _default = debounce;
exports.default = _default;